import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter} from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { Button, notification } from 'antd';


//if (process.env.REACT_APP_ENVIRONMENT === 'prod') console.log = () => null;

// firebase-messaging-sw.js used to be registered here at scope "/". That was
// never used for push -- Firebase messaging registers it itself under
// /firebase-cloud-messaging-push-scope -- but it shared scope "/" with the app's
// own service worker, so the two replaced each other on every page load.


ReactDOM.render(
  
    <BrowserRouter>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </BrowserRouter>
  
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
serviceWorker.register();

// Keep long-open pages current. The browser only looks for a new service worker
// on navigation, which a page left open all shift never does, so check
// periodically and whenever the app comes back to the foreground. A new worker
// takes over as soon as it installs (skipWaiting, see craco.config.js); when it
// does, ask the user to refresh rather than reloading underneath them, which
// could interrupt a check-in in progress.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  const hadController = !!navigator.serviceWorker.controller;
  let promptShown = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // First install also fires this (clientsClaim); there is no old version then.
    if (!hadController || promptShown) return;
    promptShown = true;
    notification.info({
      key: 'app-update',
      message: 'App updated',
      description: 'A new version of Work Alone is available.',
      duration: 0,
      btn: <Button type="primary" onClick={() => window.location.reload()}>Refresh</Button>,
    });
  });

  navigator.serviceWorker.ready.then((registration) => {
    const checkForUpdate = () => registration.update().catch(() => {});
    setInterval(checkForUpdate, 30 * 60 * 1000);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') checkForUpdate();
    });
  });
}
